import { withAnimation } from '../../tools/withAnimation';
import { withStyles } from '../../tools/withStyles';
import { Component } from './Secuence';

export const Secuence = withAnimation()(withStyles(() => ({}))(Component));
